import { Alert, Button, Col, Row } from "react-bootstrap";
import Addicon from "../assets/png/light.png";
import PlaySvg from "../assets/svg/playcircled.svg";
import FileSvg from "../assets/svg/file.svg";
import RightArrow from "../assets/svg/arrowright.svg";
import { forwardRef, useEffect, useRef, useState } from "react";
// import { Storage } from "@aws-amplify/storage";
import DatePicker from "react-datepicker";
// import moment from "moment/moment";
import dayjs from "dayjs";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useSnackbar } from "notistack";
import backArrow from "../assets/svg/circle_arrow_back.svg";
import { Link, useNavigate } from "react-router-dom";
import {
  checkGlueStatus,
  fileUpload,
  getJobRunId,
  getS3Url,
} from "../api/Service";
import axios from "axios";
import { useAuth } from "../../../authContext/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../axiosinterceptor";
import ProgressModal from "./ErrorAndProgressModal/ProgressModal";
import ErrorModal from "./ErrorAndProgressModal/ErrorModal";

const TabSection = ({ type, setFiles, fileDetails, switchTab, setType }) => {
  const navigate = useNavigate();
  const { userEmail } = useAuth();
  const [s3Uri, setS3Uri] = useState("");
  const [completed, setCompleted] = useState("0");
  const [loadId, setLoadId] = useState("");
  const [progress, setProgress] = useState(0);
  const [circleColor, setCircleColor] = useState("blue");
  const [jobId1, setJobId1] = useState("");
  const [callCheckStatusFunction, setCallCheckStatusFunction] = useState(false);
  const [filess, setFiless] = useState([]);
  const [isStartSelected, setIsStartSelected] = useState(false);
  const [showBar, setShowBar] = useState(true);
  const [isEndDateSelected, setIsEndDateSelected] = useState(false);
  const [stepFunResponse, setStepFunResponse] = useState({
    response: {},
    isCalled: false,
  });
  const [isRunDisabled, setIsRunDisabled] = useState(false);
  // const [historyFunResponse, setHistoryFunResponse] = useState([]);
  // const [responseProgressType, setResponseProgressType] = useState("");
  const [alertStatus, setAlert] = useState(false);
  // const [ProgressStatus, setStatus] = useState("start");
  const fileReference = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [auditDownloadFileStatus, setAuditDownloadFileStatus] = useState(
    "Download Audit File"
  );
  const [progressModalShow, setProgressModalShow] = useState(false);
  const [errorModalShow, setErrorModalShow] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");
  const [progressmModal, setProgressModal] = useState(0);
  const [errorFileUrl, setErrorFileUrl] = useState(null);
  const [isSuccess, setIsSuccess] = useState(null);
  const [validationResponse, setValidationResponse] = useState(null);
  let intervalId = null;
  //console.log("file:::", fileDetails);
  useEffect(() => {
    if (callCheckStatusFunction) {
      intervalId = setInterval(async () => {
        checkGlueJobStatus(jobId1, intervalId);
      }, 10000);
    }

    // Cleanup function to clear the interval when component unmounts or when callCheckStatusFunction becomes false
    return () => {
      clearInterval(intervalId);
    };
  }, [callCheckStatusFunction, jobId1]);

  useEffect(() => {
    if (completed === "1" && validationResponse) {
      if (validationResponse.message === "warnings found" && validationResponse) {
        WarningModal(validationResponse);
      }
    }
    console.log("useEffct::::", completed, validationResponse);
  }, [completed, validationResponse]);

  const checkGlueJobStatus = async (jobId, intervalId) => {
    try {
      const response = await checkGlueStatus(jobId);
      //console.log("STATUS:::::", response);
      const gg = response.JobRun;
      const jobRunState = response.JobRun.JobRunState;
      if (jobRunState === "RUNNING") {
      const rawProgress = Math.min((gg.ExecutionTime / gg.Timeout) * 100, 95);
      const roundedProgress = Math.floor(rawProgress);

        setProgress(roundedProgress);
      } else if (jobRunState === "FAILED") {
        //console.log("Failed");
        setShowBar(false);
        clearInterval(intervalId);
        setProgress(0);
        setCircleColor("red");
        setCallCheckStatusFunction(false);
        setCompleted("-1");
        enqueueSnackbar("Error processing the file", {
          variant: "Error",
        });
      } else if (jobRunState === "SUCCEEDED") {
        //console.log("Success");
        setShowBar(false);
        clearInterval(intervalId);
        setProgress(100);
        setCircleColor("green");
        setCallCheckStatusFunction(false);
        setCompleted("1");
        enqueueSnackbar("Successfully uploaded the file", {
          variant: "success",
        });
      } else {
        //console.log("Stopping interval");
        clearInterval(intervalId);
      }
    } catch (error) {
      console.log("Error checking Glue job status:", error.message);
    }
  };
  const callGlueJob = async (url) => {
    try {
      const result = await getJobRunId(url);
      setCallCheckStatusFunction(true);
      //console.log("GLUE:::", result);
      setJobId1(result);
    } catch (err) {
      console.log("Call_GLUE_JOB_ERROR::", err.message);
    }
  }; // CSV file upload
  const handleUploads = async (file, type, folder) => {
    //console.log(loadId, "");
    console.log(
      `${folder}/${file.name}`,
      `input/${file.name}` // Header.csv
    );
    console.log("UPLOADS:::", { file, type, folder, loadId });

    try {
      const result = await getS3Url(folder, file.name);
      const { url, fields } = result;
      const formData = new FormData();
      Object.keys(fields).forEach((key) => {
        formData.append(key, fields[key]);
      });
      formData.append("file", file);

      const uploadData = await fileUpload(url, formData);
       console.log("UPLOADED:::", uploadData, url);
      //to show Run button and should be enabled
      setIsRunDisabled(false);

      enqueueSnackbar(
        type === "hcp" || type === "csv"
          ? "Csv files uploaded successfully"
          : "Date range Uploaded successfully",
        { variant: "success" }
      );

      // if (type === "hcp") {
      //   switchTab("selectDates");
      // } else {
      //   switchTab("uploadTile");
      // }

      
    } catch (error) {
      //console.log(error, "err");
      enqueueSnackbar(error.message, { variant: "error" });
    }
  };


  // Uploaded HCP files
  const newUpload = async (files, type, loadnumber) => {
    const uploadedFiles = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileName = file.name;
      try {
        const result = await getS3Url(loadnumber, file.name);
        const { url, fields } = result;
        const formData = new FormData();
        Object.keys(fields).forEach((key) => {
          formData.append(key, fields[key]);
        });
        formData.append("file", file);
        const uploadData = await fileUpload(url, formData);
        sessionStorage.setItem("filename", loadnumber);

        const filePath = `s3://${process.env.REACT_APP_HCP_BUCKET_NAME}/public/${loadnumber}/`;
        // const filePath = `s3://test-sridevi/${folderName}/${fileName}`;  
        uploadedFiles.push(filePath);
      } catch (error) {
        toast.error("Error Uploading File");
        //console.log(`Error uploading file ${fileName}:`, error);
      }
    }
    //alert("File Uploaded successfully");
    // toast.success("File Uploaded successfully");
    // callGlueJob(`s3://hcp-file-dev/public/${loadnumber}`);
    showProgressModal();
     // Validate the uploaded files before proceeding with the Glue job
     
  try {

    const validationResponse = await validateFiles(uploadedFiles);
    setValidationResponse(validationResponse);

    if (validationResponse.message === "no issues and warnings found"|| validationResponse.message === "warnings found") {
      // If files are valid, proceed with Glue job
      toast.success("File Validation successfull");
      // if (validationResponse.message === "warnings found") {
      //   WarningModal(validationResponse);
      // }
      callGlueJob(`s3://${process.env.REACT_APP_HCP_BUCKET_NAME}/public/${loadnumber}`);
      enqueueSnackbar("Uploaded other files successfully", { variant: "success" });

         if (type === "hcp") {
          switchTab("selectDates");
        } else {
          switchTab("uploadTile");
        }
  
  

    }else if (validationResponse.message === "Issues found") {
      WarningModal(validationResponse);
    }
     else if (validationResponse.message === "Issues and warnings found") {
      
      openErrorModal(validationResponse);
      
    }  else if(validationResponse.message === "REJECTED"||"FAILED"){
      toast.error("Oops! The Glue job ran into an unexpected issue. Please try again latter")
    }
   
    else {

      showValidationErrors(validationResponse.errors);
    }
  } catch (error) {
    if (error.message) {
      const { status, data } = error.message;
      if ([500, 502, 504].includes(status)) {
        toast.error(data?.message || "An error occurred while validating files.");
      }
    } else {
      toast.error("Error while validating files. Please try again.");
    }

    // Ensure the tab remains on upload if validation fails
          // switchTab("selectDates");
    switchTab("upload");
    return; // Prevent further execution on error
  
  }
  
};



// const validateFiles = async (hcpData) => {
//   let uploadProgress = 10;
//   setProgressModal(uploadProgress);
//   let interval ;

//   try {
//     interval = setInterval(() => {
//       if (uploadProgress < 90) {
//         uploadProgress += 10; 
//         setProgressModal(uploadProgress);
//       }
//     }, 500);

//     const payload = {
//       hcp_data: hcpData,
//     };

//     // Make the API call
//     const response = await axiosInstance.post(
      
//       "https://2qsy8i5q68.execute-api.ap-southeast-2.amazonaws.com/call_glue_job_data_validation_ics_v1",
//       payload
//     );

//     const jobId = response.data?.job_run_id
//     console.log(response.data.job_run_id
//       ,"resposne validation")
// if(!jobId){
//   throw new Error("Job Id not received from api")
// }


//     await new Promise((resolve) => setTimeout(resolve, 10000));

//     const jobStatusReposne = await axiosInstance.post(
     
//       "https://frr70fv796.execute-api.ap-southeast-2.amazonaws.com/glue_job_notification_ics_v1",
//       {job_run_id:jobId}
//     )

//     clearInterval(interval); 
//     uploadProgress = 100;
//     setProgressModal(uploadProgress);

//     // Delay a little to give visual feedback of 100% completion
//     setTimeout(() => {
//       closeProgressModal();
//     }, 1000); // Close the modal after 500ms

//     // return response.data; 
//     console.log(jobStatusReposne.data.message === "RUNNING","123")
//     if(jobStatusReposne.data.message === "RUNNING"){
//         return jobStatusReposne()
//     }else{
//       return jobStatusReposne.data;
//     }
    
//   } catch (error) {
    
//     clearInterval(interval); 
//     closeProgressModal();
//     toast.error(error.response?.data?.message || "Validation failed. Please try again.");
//     switchTab("upload"); // Keep the user on the upload tab if validation fails 
//     // switchTab("selectDates");
//     console.log(error.response?.data?.message,"--jyotitry catch=====")
//     return null;
  
//     // switchTab("upload");
//     // toast.error(`Error: ${error.message}`);
//   }
// };

const validateFiles = async (hcpData) => {
  let uploadProgress = 10;
  setProgressModal(uploadProgress);
  let interval;

  try {
    interval = setInterval(() => {
      if (uploadProgress < 90) {
        uploadProgress += 10;
        setProgressModal(uploadProgress);
      }
    }, 500);

    const payload = {
      hcp_data: hcpData,
    };

    // Initial API call to start the job
    const response = await axiosInstance.post(
      "/ics_call_glue_job_data_validation_ics_v1",
      payload
    );

    const jobId = response.data?.job_run_id;
    // console.log(jobId, "Job ID from validation API");

    if (!jobId) {
      throw new Error("Job ID not received from API");
    }

    await new Promise((resolve) => setTimeout(resolve, 30000));
    const checkJobStatus = async () => {
      const jobStatusResponse = await axiosInstance.post(
        "/ics_glue_job_notification_ics_v1",
        { job_run_id: jobId }
      );

      // console.log(jobStatusResponse.data.message, "Current job status");

      if (jobStatusResponse.data.message === "RUNNING") {
        await new Promise((resolve) =>setTimeout(resolve,10000))
        return checkJobStatus();
      }
       else {
        return jobStatusResponse.data;
      }
    };

    // Start checking job status
    const finalResult = await checkJobStatus();

    clearInterval(interval);
    uploadProgress = 100;
    setProgressModal(uploadProgress);

    setTimeout(() => {
      closeProgressModal();
    }, 1000);

    return finalResult;
  } catch (error) {
    clearInterval(interval);
    closeProgressModal();
    toast.error(error.response?.data?.message || "Validation failed. Please try again.");
    switchTab("upload");
    // console.error("Error in validateFiles:", error);
    return null;
  }
};
const showValidationErrors = (errors) => {
  // Handle showing errors to the user (e.g., show in UI or console log)
  errors.forEach((error) => {
    toast.error(`Error: ${error.message}`);
  });
    enqueueSnackbar("Uploaded other files successfully", {
      variant: "success",
    });
  };


  const showProgressModal = () => {
    setProgressModalShow(true);
    // Logic to show progress modal (e.g., using a React state or library like Material-UI)
    // console.log("Showing progress modal...");
  };
  
  // // Helper function to close progress modal
  const closeProgressModal = () => {
    setProgressModalShow(false);
    setProgressModal(10);
    // console.log("Closing progress modal...");
  };
  
  // // Helper function to open error modal
  const openErrorModal = (validationResponse) => {
    setErrorModalShow(true);
    setIsSuccess(false); 
   setErrorFileUrl(validationResponse);
    switchTab("upload");
    // console.log("Opening error modal with download link:",validationResponse);
  
    // toast.error("Validation issues found. Please review the issue file.");
  };
  const WarningModal = (validationResponse) => {
    setErrorModalShow(true); 
    setIsSuccess(true); 
    setErrorFileUrl(validationResponse);
    // console.log("Opening warning modal:",validationResponse);
  
    // toast.error("Validation issues found. Please review the issue file.");
  };
  //console.log("checkemali", userEmail);
  const handleCsvFormat = () => {
    const { uploadFile, ...dateRange } = fileDetails;
    const start = dayjs(dateRange.startDate).format("D-MMM-YY");
    const end = dayjs(dateRange.endDate).format("D-MMM-YY");
    const orgName = "iMedX";
    const sliceduser = String(userEmail).split("@")[0];
    const currentTimestamp = new Date().getTime();
    const loadIds = `${sliceduser}-${orgName}-${currentTimestamp}`;
    const created_by = sessionStorage.getItem("userId");
    const organization_id = sessionStorage.getItem("organizationId");
    const country_id = sessionStorage.getItem("countryId");
    setLoadId(loadIds);
    //const csvData = `start_date,end_date,organization_name,user_name,user_id,email_address,load_id\r\n${start},${end},${orgName},${userName},${id},${userEmail},${loadIds}`;
    const csvData = `start_date,end_date,organization_id,country_id,file_name,created_by\r\n${start},${end},${organization_id},${country_id},s3://${process.env.REACT_APP_HCP_BUCKET_NAME}/public/${loadIds},${created_by}`;
    //console.log(start, end, loadIds, "hghjk");
    const file = new File(
      [csvData],
      process.env.REACT_APP_EXPORT_CSV_FILE_NAME,
      { type: "text/csv" }
    );
    handleUploads(file, "csv", loadIds);
    newUpload(filess, "txt", loadIds);
    // console.log("UPLOAD_DATA:::", {
    //   start,
    //   end,
    //   filess,
    //   userEmail,
    //   loadIds,
    //   csvData,
    //   env: process.env.REACT_APP_EXPORT_CSV_FILE_NAME,
    //   file,
    // });
    enqueueSnackbar(
      type === "hcp"
        ? "File uploaded successfully"
        : "Date range Uploaded successfully",
      { variant: "success" }
    );
  };

  const handleFileUpload = () => {
    fileReference.current.click();
  };

  const handledownloadFileClick = () => {
    setAuditDownloadFileStatus("Downloading...");
    const filename = sessionStorage.getItem("filename");
    let trimmedfilename = filename.replace(/\s+/g, "");
    const csvFilename = trimmedfilename + ".csv";
    axiosInstance
      .get(
        `/ics_download_audit_files_work_flow_tool_ics_v1?file_name=${csvFilename}`
      )
      .then((response) => {
        const { url } = response.data;
        const link = document.createElement("a");
        link.href = url;
        //console.log(url, response, "checkurl:::");
        link.setAttribute("download", csvFilename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setAuditDownloadFileStatus("Download Again");
      });
  };
  const resetAllStates = () => {
    setS3Uri("");
    setShowBar(true);
    setCompleted("0");
    setLoadId("");
    setProgress(0);
    setCircleColor("blue");
    setJobId1("");
    setCallCheckStatusFunction(false);
    setFiless([]);
    setIsStartSelected(false);
    setIsEndDateSelected(false);
    fileDetails.startDate=null;
    fileDetails.endDate=null;
    setType("upload");
    setAuditDownloadFileStatus("Download Audit file");
  };

  const handleBack = () => {
    resetAllStates();
  };
  const handleBackToLink = () => {
    navigate("/viewdashboard");
  };

  const handleProgress = async () => {
    //console.log("RUNBTN::::");
    setIsRunDisabled(true);
    showProgressModal();

    handleCsvFormat();


    if (fileDetails.startDate === null || fileDetails.endDate === null) {
      setAlert(true);
    } else {
      setTimeout(() => {
        console.log("progress on the way");
      }, 2000);
    }
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const validFiles = selectedFiles.filter(file => {
      const fileName = file.name.toLowerCase();
      return fileName.endsWith(".hcp") || fileName.endsWith(".txt");
    });
    if (validFiles.length > 0) {
      // Proceed with valid files
      setFiless(validFiles);
      switchTab("selectDates");
    } else {
       toast.error("Only .hcp and .txt are allowed. Please select valid files.");
      fileReference.current.value = ""; // Clear the input
    }
     // setFiless(selectedFiles);
    // switchTab("selectDates");
  };

  const StartDates = forwardRef(({ value, onClick }, ref) => (
    <span className="periodText" onClick={onClick} ref={ref} role="button">
      {value === ""
        ? "StartDate - EndDate"
        : value.includes("-") && fileDetails.endDate === null
        ? `${value} EndDate`
        : value}
    </span>
  ));

  const UploadSection = () => {
    return (
      <>
        {/* <ToastContainer position="top-center"/> */}
        <section className="w-100 mt-5 pt-5 pb-3 d-flex flex-column align-items-center">
          <p>Upload The Hcp Files.(Hold Control For Multiple)</p>
          {/* <button onClick={glucose}>run glue job</button> */}

          <input
            type="file"
            className="d-none"
            ref={fileReference}
            onInput={handleFileChange}
            multiple
            accept=".hcp"
          />
          <Button
            className="w-100 py-3 primaryButton font-weight-bold"
            onClick={handleFileUpload}
          >
            <img className="addicon-files" src={Addicon} alt="add icon" />{" "}
            Browse for File(s)
          </Button>
        </section>
      </>
    );
  };
  const SelectDates = () => {
    return (
      <section className="w-100 mt-4 d-flex flex-column align-items-center ">
        <div className=" border rounded w-100 p-3 mb-4 font-weight-bold">
          <Row className="px-2 pb-4 file-upload-wrapper">
            {alertStatus && (
              <Alert variant="danger">Please Select the Period</Alert>
            )}

            {filess.length > 0 &&
              filess.map((fileName, index) => {
                // console.log(fileName);
                return (
                  <Col
                    className="d-flex align-items-center p-0"
                    key={index}
                  >
                    <img src={FileSvg} alt="file icon" />
                    <p className="m-0 ps-2">{fileName.name}</p>
                  </Col>
                );
              })}
          </Row>
          <div className="selectPeriod px-4 py-3">
            <img src={RightArrow} alt="rightArrow" />
            <span className="m-0 ps-3">Select Period:</span>
            <div className="d-flex gap-2 mt-2">
              <label className="mx-2">Start Date:</label>

              <DatePicker
                maxDate={fileDetails.endDate}
                selected={fileDetails.startDate}
                onChange={(date) => {
                  const { startDate, endDate } = fileDetails;
                  if ((endDate && date < endDate) || !startDate || !endDate) {
                    setFiles((prev) => ({
                      ...prev,
                      startDate: date,
                    }));
                  }
                }}
                onChangeRaw={(e) => {
                  const input = e.target.value;
                  if (/\d{5,}/.test(input)) {
                    e.preventDefault();
                  }
                }}
                dateFormat="dd-MM-yyyy"
              />
            </div>
            <div className="d-flex align-items-center" style={{ gap: "15px" }}>
              <label className="mx-2 py-3">End Date:</label>
              <DatePicker
                selected={fileDetails.endDate}
                minDate={fileDetails.startDate}
                onChange={(date) => {
                  const { startDate, endDate } = fileDetails;
                  if (
                    (startDate && date > startDate) ||
                    !endDate ||
                    !startDate
                  ) {
                    setFiles((prev) => ({
                      ...prev,
                      endDate: date,
                    }));
                  }
                }}
                onChangeRaw={(e) => {
                  const input = e.target.value;
                  if (/\d{5,}/.test(input)) {
                    e.preventDefault();
                  }
                }}
                dateFormat="dd-MM-yyyy"
              />
              {/* <button onClick={handleCsvFormat}>save csv</button> */}
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center w-100 gap-4">
          <Button
            className="w-100 py-3 primaryButton font-weight-bold mb-4"
            onClick={handleBack}
          >
            <img
              src={backArrow}
              className="me-2"
              alt="play"
              width="28rem"
              height="28rem"
            />{" "}
            Back
          </Button>
          <Button
            className="w-100 py-3 primaryButton font-weight-bold mb-4"
            onClick={handleProgress}
            disabled={
              !(fileDetails.startDate && fileDetails.endDate) || isRunDisabled
            }
          >
            <img src={PlaySvg} className="me-2" alt="play" />
            {isRunDisabled ? "Uploading" : " Run"}
          </Button>
        </div>
      </section>
    );
  };
  const renderSection = (type) => {
    switch (type) {
      case "upload":
        return <UploadSection />;
      case "selectDates":
        return <SelectDates />;
      case "uploadTile":
        return (
          <>
            <div className="d-flex">
              <div style={{ width: 150, height: 150 }}>
                <CircularProgressbar
                  styles={buildStyles({
                    // Rotation of path and trail, in number of turns (0-1)
                    rotation: 0.25,

                    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                    strokeLinecap: "butt",

                    // Text size
                    textSize: "16px",

                    // How long animation takes to go from one percentage to another, in seconds
                    pathTransitionDuration: 0.5,

                    // Can specify path transition in more detail, or remove it entirely
                    // pathTransition: 'none',

                    // Colors
                    // pathColor: `rgba(0, 255, 0, ${progress / 100})` ?,
                    pathColor:
                      completed === "1"
                        ? `rgba(0, 255, 0, ${progress})`
                        : completed === "-1"
                        ? `rgba(255, 0, 0, ${progress})`
                        : `rgba(0, 0, 255, ${progress})`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: circleColor,
                  })}
                  value={Math.floor(progress)}
                  text={`${Math.floor(progress)}%`}
                />
              </div>
              {progress >= 0 && progress <= 2 && showBar && (
                <div style={{ marginLeft: "20px" }}>
                  <p>Cerebrum has started processing</p>
                  <p>
                    Please allow upto 10 minutes for the program to complete
                  </p>
                  <p style={{color:'#dc3545'}}>Processing in progress. Do not close or navigate.</p>
                </div>
              )}

              {progress > 2 && progress <= 20 && showBar && (
                <div style={{ marginLeft: "20px" }}>
                  <p>Cerebrum is running through the data.</p>
                  <p>
                    Please allow upto 10 minutes for the program to complete
                  </p>
                  <p style={{color:'#dc3545'}}>Processing in progress. Do not close or navigate.</p>
                </div>
              )}
              {progress > 20 && progress < 100 && showBar && (
                <div style={{ marginLeft: "20px" }}>
                  <p>Cerebrum is almost complete.</p>
                  <p>
                    Please allow upto 10 minutes for the program to complete
                  </p>
                  <p style={{color:'#dc3545'}}>Processing in progress. Do not close or navigate.</p>
                </div>
              )}

              {completed == "1" && (
                <div style={{ marginLeft: "20px" }}>
                  <p>Completed</p>
                  <br />
                  <Button
                    className="w-100 py-3 primaryButton font-weight-bold mb-4"
                    onClick={handledownloadFileClick}
                  >
                    {auditDownloadFileStatus}
                  </Button>
                  <Button
                    className="w-100 py-3 primaryButton font-weight-bold mb-4"
                    onClick={handleBack}
                  >
                    <img
                      src={backArrow}
                      className="me-2"
                      alt="play"
                      width="20px"
                      height="20px"
                    />{" "}
                    Start Again
                  </Button>
                </div>
              )}

              {completed === "-1" && (
                <>
                  <p className="mx-4">Error processing the file</p>
                  <br />
                  <Button
                    className="w-50  primaryButton font-weight-bold mb-4"
                    onClick={handleBack}
                  >
                    <img
                      src={backArrow}
                      className="me-2"
                      alt="play"
                      width="28rem"
                      height="28rem"
                    />{" "}
                    Start Again
                  </Button>
                </>
              )}
            </div>
          </>
        );
      default:
        return null;
    }
  };
  return (
    <>
    
    {progressModalShow && (
    <ProgressModal
    progressModalShow={progressModalShow}
    onClose={() => setProgressModalShow(false)}
    progress={progressmModal}
     />
    )}

      {!progressModalShow && errorModalShow && (
      <ErrorModal
    errorModalShow={errorModalShow}
    onClose={() => setErrorModalShow(false)}
    errorFileUrl={errorFileUrl}
    isSuccess={isSuccess}
     />
    )}
      {renderSection(type)}
    </>
  );
  // return renderSection(type);
  
};

export default TabSection;
